<template>
  <Button class="!px-2" size="sm" variant="tertiary">
    <ArrowPathIcon
      class="h-[18px] w-[18px]"
      :class="{ 'animate-spin': isLoading }"
    />
  </Button>
</template>

<script setup>
defineProps({
  isLoading: Boolean,
});
</script>
